/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { GetUserId } from 'nallian-shared-ui/lib/selectors';
import { Button, Container, Flex } from 'nallian-shared-ui/lib/components';
import { useTranslation } from 'react-i18next';

const RegisterTextWrapper = styled.span`
  margin-top: 0.8rem;
  margin-bottom: 1.2rem;

  && a {
    cursor: pointer;
    text-decoration: underline;
  }
`;

const GuestActions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const userId = useSelector(GetUserId);

  useEffect(() => {
    if (userId) navigate('/overview');
  }, [userId, navigate]);

  const handleLogin = useCallback(() => navigate('/overview'), [navigate]);

  const handleRegister = useCallback(() => navigate('/request-to-join'), [navigate]);

  return (
    <Container textAlign="left">
      <Flex direction="column" alignItems="flex-end" fluid>
        <Button
          btnprimary
          onClick={handleLogin}
          title={t('loginToYourAccount')}
          content={t('login')}
        />
        {!window.appSettings?.hideRequestToJoin && (
          <RegisterTextWrapper>
            {t('dontHaveAnAccountYet')}&nbsp;
            <a onClick={handleRegister} role="button" tabIndex="0">
              {t('requestToJoin')}
            </a>
          </RegisterTextWrapper>
        )}
      </Flex>
    </Container>
  );
};

export default GuestActions;
